var CardType = {
	MAE: { name: 'cardTypes.mae', img: 'maestro-curved-32px.png'},
    MC: { name: 'cardTypes.mc', img: 'mastercard-curved-32px.png'},
    VIS: { name: 'cardTypes.vis', img: 'visa-curved-32px.png'},
    AMEX: { name: 'cardTypes.amex', img: 'american-express-curved-32px.png'},
    BCM: { name: 'cardTypes.bcm', img: 'bancontact-32px.png'},
    REG: { name: 'cardTypes.reg', img: 'favicon.ico'},
    MPPF: { name: 'cardTypes.mppf', img: 'favicon.ico'}
};

module.exports = CardType;


// WEBPACK FOOTER //
// ./src/enums/CardType.js